"use client";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const ViewVendorOrder = () => {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [orderId, setOrderId] = useState("");
  const [loading, setLoading] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-items-for-vendor/${id}`,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
          },
        }
      );

      setItems(res.data.data || []);

      if (res.data.data?.length > 0) {
        setOrderId(res.data.data[0].order_id);
      }
    } catch (err) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6 text-gray-600">Loading...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto bg-white p-6 rounded-lg shadow-sm border">

        <h1 className="text-2xl font-semibold mb-4 text-gray-800">
          Order Items – {orderId}
        </h1>

        {/* TABLE */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b bg-gray-100 text-gray-700">
                <th className="py-2 px-3 text-left">Image</th>
                <th className="py-2 px-3 text-left">Order ID</th>
                 
                <th className="py-2 px-3 text-left">Order Date</th>
                <th className="py-2 px-3 text-left">Original Name</th>
                <th className="py-2 px-3 text-left">Material</th>
                <th className="py-2 px-3 text-left">Product Link</th>
                <th className="py-2 px-3 text-left">Item Details</th>
                <th className="py-2 px-3 text-left">Quantity</th>
              </tr>
            </thead>

            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center py-5 text-gray-500">
                    No Items Found
                  </td>
                </tr>
              ) : (
                items.map((i, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="py-2 px-3">
                      <img
                        src={i.vendor_image}
                        className="w-16 h-16 rounded border object-cover cursor-pointer"
                        onClick={() => setPreviewImage(i.vendor_image)}
                      />
                    </td>

                    <td className="py-2 px-3">{i.order_id}</td>
                    <td className="py-2 px-3">
                      {new Date(i.order_date).toLocaleDateString()}
                    </td>
                    <td className="py-2 px-3">{i.item_original_name}</td>
                    <td className="py-2 px-3">{i.product_material}</td>

                    <td className="py-2 px-3">
                      <a
                        href={i.product_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        {i.product_link}
                      </a>
                    </td>

                    <td className="py-2 px-3 whitespace-pre-line">
                      {i.item_details}
                    </td>
                     <td className="py-2 px-3 whitespace-pre-line">
                      {i.qty}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* IMAGE POPUP */}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg max-w-2xl w-full relative">

            <button
              className="absolute top-3 right-3 text-gray-700 hover:text-black text-xl"
              onClick={() => setPreviewImage(null)}
            >
              ✖
            </button>

            <img
              src={previewImage}
              className="w-full object-contain max-h-[70vh] rounded"
            />

            <div className="flex justify-end gap-3 mt-4">
              <a
                href={previewImage}
                download
                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
              >
                Download
              </a>

              <button
                onClick={() => setPreviewImage(null)}
                className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default ViewVendorOrder;
